import { AppProvider } from "@shopify/polaris";
import translations from "@shopify/polaris/locales/en.json";
import { useAppBridge } from "@shopify/app-bridge-react";
import axios, { InternalAxiosRequestConfig } from "axios";
import Main from "./components/Main";

const MyApp = () => {
  const shopify = useAppBridge();

  const authAxios = axios.create();

  if (process.env.NODE_ENV === "development") {
    authAxios.defaults.baseURL = "http://localhost:5002";
  }

  authAxios.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const token = await shopify.idToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }
  );

  return (
    <AppProvider i18n={translations}>
      <Main {...{ authAxios }} />
    </AppProvider>
  );
};

export default MyApp;
